import { useTheme } from '@mui/material';
import { TextSDefaultWrapper } from './styles';
import { HTMLAttributes, ReactNode } from 'react';

export interface ITextSDefaultProps
  extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  weight?: 'Regular' | 'Bold' | 'Semibold' | 'Medium';
}

const fontWeightTypes = {
  Regular: 'Rg',
  Bold: 'B',
  Semibold: 'Sb',
  Medium: 'Md',
};

const TextS = ({
  children,
  weight = 'Regular',
  ...props
}: ITextSDefaultProps) => {
  const theme = useTheme();
  return (
    <TextSDefaultWrapper
      weight={weight}
      {...props}
      style={{
        ...props.style,
        fontWeight: theme.typography?.fontWeight?.[fontWeightTypes[weight]],
      }}
    >
      {children}
    </TextSDefaultWrapper>
  );
};

export default TextS;
